import LogoDante from "../../assets/header/dante-dev.png";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        <img className="footerImg" src={LogoDante} /> ℠ 2024
      </p>
    </footer>
  );
};

export default Footer;
